<div (copy)="blockCopy()" (cut)="blockCut()">
  <h1 class="page-title">Question {{assessment.currentQuestionSequence}} Complete</h1>
  <form (submit)="submitConfidence()" appBlockPrint class="no-print">
    <fieldset class="field-group">
      <legend class="label field-group__label">How confident are you about your response?</legend>
      <ul class="toggle-buttons">
        <li class="toggle-button">
          <input class="input input--radio toggle-button__input is-vishidden" id="confidence-high" name="confidence"
            [(ngModel)]="confidence.confidenceLevel" type="radio" [value]="1" required>
          <label for="confidence-high" class="label label--inline toggle-button__label">High</label>
        </li>
        <li class="toggle-button">
          <input class="input input--radio toggle-button__input is-vishidden" id="confidence-low" name="confidence"
            type="radio" [(ngModel)]="confidence.confidenceLevel" [value]="0" required>
          <label for="confidence-low" class="label label--inline toggle-button__label">Low</label>
        </li>
      </ul>
    </fieldset>

    <fieldset class="field-group">
      <legend class="label field-group__label">How relevant is the item to the credential?</legend>
      <ul class="toggle-buttons">
        <li class="toggle-button">
          <input class="input input--radio  toggle-button__input is-vishidden" [value]="1" [(ngModel)]="confidence.relevanceLevel"
            id="relevance-high" name="relevance" type="radio" required>
          <label for="relevance-high" class="label label--inline toggle-button__label ">High</label>
        </li>
        <li class="toggle-button">
          <input class="input input--radio  toggle-button__input is-vishidden" [(ngModel)]="confidence.relevanceLevel"
            id="relevance-low" [value]="0" name="relevance" type="radio" required>
          <label for="relevance-low" class="label label--inline toggle-button__label ">Low</label>
        </li>
      </ul>
    </fieldset>
    <button type="submit" [disabled]="confidence.relevanceLevel === null || confidence.confidenceLevel === null" class="button"
      value="Submit">Submit</button>
  </form>
</div>